<!-- Notification View -->
@if (mode === 'notification' && messages.length > 0) {
  <sh-notification-item id="subscribed-notifications-notification-item-1" sticky
    [new]="!messages[selectedNotification-1]['read']" [visible]="notificationOpen" type="information"
    style="width: 320px;" (close)="resetNotification()" duration="15000">
    @for (message of messages; track message; let i = $index) {
      <div [hidden]="i + 1 !== selectedNotification"
        style="display: flex; padding-bottom: 8px; align-items: center; justify-content: space-between;">
        <div style="display: flex; gap: 8px;  align-items: center;">
          <sh-icon id="subscribed-notifications-icon-2" [icon]="message['type']" size="xs"></sh-icon>
          <sh-text id="subscribed-notifications-text-3" size="title-1">{{message['title']}}</sh-text>
        </div>
        <div style="display: flex; gap: 8px;  align-items: center;">
          <sh-badge id="subscribed-notifications-badge-4"></sh-badge>
          <sh-icon id="subscribed-notifications-icon-cancel" button icon="cancel" size="xs" (click)="markAsRead(message['id'])"></sh-icon>
        </div>
      </div>
    }
    @for (message of messages; track message; let i = $index) {
      <div [hidden]="i + 1 !== selectedNotification">
        {{message['message']}}
      </div>
    }
    <div slot='footer' style="width: 100%; display: flex; align-items: center;">
      <sh-pagination id="subscribed-notifications-pagination-6" [pages]='messages.length' [current-page]='selectedNotification'
      (click)="switchNotification($event)"></sh-pagination>
    </div>
  </sh-notification-item>
}


<!-- Menu List View -->
@if (mode === 'menulist') {
  <sh-list id="subscribed-notifications-list-7" flat integrated>
    @if (messagesCenter.length === 0) {
      <sh-list-item id="subscribed-notifications-list-item-no-notifications-to-displ" [attr.label]="'notifications.empty' | transloco" [clickable]="false">
      </sh-list-item>
    }
    @for (message of messagesCenter; track message; let i = $index) {
      <sh-list-item id="subscribed-notifications-list-item-9" [label]="message['title']"
        [info]="message['timestamp']">{{message['message']}}
        @if (!message['read']) {
          <sh-badge id="subscribed-notifications-badge-10" slot="right"></sh-badge>
        }
      </sh-list-item>
    }
  </sh-list>
}